module.exports = __webpack_public_path__ + "img/cs-protrain-6.c5c3178e.png";